module.exports = __webpack_public_path__ + "img/138.35f0c866.jpg";